import { Filters } from "./Filters";
import { Pagination } from "./Pagination";
import { DataView } from "./DataView";
import * as table from "./Table";

export const Table = { Filters, Pagination, DataView, ...table };
